import axios from "axios";
import config from "../config";
import { DetailsResponse } from "./ResponseModels/DetailsResponse";
import DetailsResponseFake from "./json/DetailsResponseFake.json";
import { FakeAxiosResponse } from "./FakeAxiosResponse";

export async function GetDetailsModel(workorderUuid: string) {
  let response = null;
  if (!config.useFakeModels) {
    response = axios
      .get<DetailsResponse>(config.getDetailsEndpoint, {
        params: {
          uuid: workorderUuid,
        },
      })
      .catch((e) => {
        // TODO manage
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(DetailsResponseFake));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
